<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
      <ActivatorButton
        :parent-attrs="dialogAttrs"
        :parent-on="dialogOn"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
      />
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <span
          v-if="htmlMessage"
          style="white-space: pre-line"
          v-html="text"
        />

        <v-text-field
          v-else
          v-model="localText"
          :disabled="!editable"
          :hint="hint"
          :label="label"
          persistent-hint
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="onOk"
          aria-label="Ok"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogBase from './DialogBase.vue'
import { defaultVTooltipProps } from '@/utils/defaultProps'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  props: {
    text: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    htmlMessage: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    localText: null,
    status: null,
    defaultVTooltipProps,
  }),

  watch: {
    dialog(val) {
      if (val) {
        this.localText = this.text
      }
    },
  },

  methods: {
    onOk() {
      this.$emit('confirmed', this.localText)
      this.dialog = false
    },
  },
}
</script>
